import React, { useEffect, useMemo } from 'react';
import Page from '../components/Page';
import StickyMenu from '../components/StickyMenu';
import CeremonyBefore from '../components/CeremonyBefore';
import CeremonyDuring from '../components/CeremonyDuring';
import OneBallotResource from '../resources/Ballot/One';
import ObjectiveStateResource from '../resources/ObjectiveState';
import watchObjectiveState from '../resources/ObjectiveState/watchObjectiveState';
import watchBallotScores from '../resources/Ballot/watchBallotScores';
import AllLeaguesForUserResource from '../resources/League/AllForUser';
import { CurrentUserMustResource } from '../resources/Auth/CurrentUserMust';
import { getBallotShape } from '../resources/ObjectiveState/getBallotShape';
import { thisOscarsYear } from '../config/constants';
import { setDelayMs } from '../util/spoilerDelayBuffer';

let HomePage = () => {
  let objectiveState = ObjectiveStateResource.use();

  let currentUser = CurrentUserMustResource.use();
  let ballot = OneBallotResource.use(currentUser.id);
  let leagues = AllLeaguesForUserResource.use(currentUser.id);

  useEffect(watchObjectiveState, []);
  useEffect(watchBallotScores, []);
  useEffect(() => {
    setDelayMs(currentUser.spoilerDelayMs || 0);
  }, [currentUser.spoilerDelayMs]);

  let ContentComponent = useMemo(() => {
    if (objectiveState.didCeremonyStart) return CeremonyDuring;
    return CeremonyBefore;
  }, [objectiveState]);

  return (
    <>
      <Page className="HomePage">
        <ContentComponent
          currentUser={currentUser}
          leagues={leagues}
          ballot={ballot}
        />
      </Page>
      <StickyMenu />
    </>
  );
};

export async function getStaticProps() {
  const ballotShape = await getBallotShape(thisOscarsYear);
  return {
    props: {
      data: {
        ballotShape,
      },
    },
  };
}

export default HomePage;
